import { Theme } from '@mui/material'

export const useMinimizedBreadcrumbStyles = {
  root: { whiteSpace: 'nowrap' },
  ol: { flexWrap: 'nowrap', overflow: 'hidden' },
  li: { overflow: 'hidden', textOverflow: 'ellipsis' },
}

const useStyles = {
  bannerHomeIcon: (theme: Theme) => ({
    fontSize: '16px',
    color: theme.palette.text.secondary,
    display: 'block',
    minHeight: theme.spacing(3),
  }),
  breadcrumbLink: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
}
export default useStyles
